module.exports = __webpack_public_path__ + "img/forum-jl.89fa2837.png";